var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-spinner-container"},[_c('div',{staticClass:"loading-spinner"},[_c('b-icon',{attrs:{"icon":"arrow-clockwise","animation":"spin-pulse"}}),_c('p',[_vm._v(_vm._s(_vm.$t('loading'))+"...")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }